import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ManageSurveyQuestionsRPC } from "./manageSurveyQuestionsRPC";

export class ManageSurveyQuestionsRPCClientImpl extends ManageSurveyQuestionsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ManageSurveyQuestionsRPC.Request): Promise<LeoRPCResult<ManageSurveyQuestionsRPC.Response, ManageSurveyQuestionsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/ManageSurveyQuestions",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ManageSurveyQuestionsRPC.ResponseDTO,
      ManageSurveyQuestionsRPC.Errors.ErrorsDTO,
      ManageSurveyQuestionsRPC.Response,
      ManageSurveyQuestionsRPC.Errors.Errors
    >(
      response,
      "survey/ManageSurveyQuestions",
      ManageSurveyQuestionsRPC.Response.fromDTO,
      ManageSurveyQuestionsRPC.Errors.fromDTO
    );
  }
}
